import axiosInst from "../../Config";
import { Decrypt_Value, Encrypt_Value } from "../EncryptDecrypt";

export const RefundList_Api = async () => {
  const Pat_ID =
    localStorage.getItem("PID") &&
    Decrypt_Value(localStorage.getItem("PID"), "vozoportal");

  const payload = {
    patient: Pat_ID,
  };

  const encrypted = Encrypt_Value(payload, "vozo");

  return axiosInst.post("/vozo/patient/refundlists", encrypted);
};
